import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Subheader from 'components/prism/subheader';
import ObjectiveList from 'components/prism/objectiveList';
import TaskContentSection from 'views/user/task/components/taskContentSection';
import { SystemText } from '@salesperformanceint/e4shared';
import { apiGet } from 'services';

export const Objectives = ({ profile, objectiveId }) => {
    if (!profile?.id) {
        return null;
    }

    const [status, setStatus] = useState('outstanding-awaiting');
    const [count, setCount] = useState(0);
    const [showDetail, setShowDetail] = React.useState(false);
    const [currentObjective, setCurrentObjective] = React.useState(null);
    const [objectiveIdToView, setObjectiveIdToView] = React.useState(objectiveId);

    const { user } = useSelector(state => state.user);

    const api = {
        loadObjective: (objectiveId, refresh) => {
            apiGet(`profile/-1/task/${objectiveId}${refresh ? '?refresh=true' : ''}`, user.guid, response => {
                if (response.completed_Video_Asset?.insights_Id) {
                    response.insights_Id = response.completed_Video_Asset.insights_Id;
                    response.insights = response.completed_Video_Asset.insights
                        ? JSON.parse(response.completed_Video_Asset.insights)
                        : null;
                    response.video = response.insights?.videos ? response.insights.videos[0] : { insights: {} };
                }

                setCurrentObjective(response);
                setShowDetail(true);
            });
        },
    };

    const text = {
        buttons: {
            backToObjectives: SystemText('TeamMember/Objectives/BackTo', profile.first_Name),
        },
    };

    const handleStatusChange = newStatus => {
        setStatus(newStatus);
    };

    const handleDataChange = data => {
        setCount(data?.records || 0);
    };

    const getTitle = () => {
        if (status === 'completed') {
            return SystemText('ObjectiveList/Statuses/Completed');
        }
        return SystemText('ObjectiveList/Statuses/Outstanding');
    };

    const displayDetails = objectiveId => {
        api.loadObjective(objectiveId);
    };

    const displayObjectiveList = () => {
        setShowDetail(false);
        setCurrentObjective(null);
    };

    React.useEffect(() => {
        if (objectiveId) {
            api.loadObjective(objectiveId);
        }
        setObjectiveIdToView(null);
    }, [objectiveIdToView]);

    return (
        <div className="mt20">
            {!showDetail ? (
                <>
                    <Subheader title={getTitle()} count={count} />
                    <ObjectiveList
                        profileId={profile.id}
                        onStatusChange={handleStatusChange}
                        onDataChange={handleDataChange}
                        displayDetails={displayDetails}
                    />
                </>
            ) : (
                <>
                    <button className="crumb-link mb20" onClick={() => displayObjectiveList()}>
                        <i className="fa fa-arrow-left" />
                        {text.buttons.backToObjectives}
                    </button>
                    <TaskContentSection task={currentObjective} setTask={setCurrentObjective} profile={profile} />
                </>
            )}
        </div>
    );
};

export default Objectives;
